import Dashboard from '../pages/user/Dashboard';
import CreateCase from '../pages/user/CreateCase';
import CaseDetail from '../pages/user/CaseDetail';
import AcceptInvite from '../pages/user/AcceptInvite';
import MyProfile from '../pages/user/MyProfile';
import VerifiedMember from '../middlewares/VerifiedMember';
import Authenticated from '../middlewares/Authenticated';
import CompleteSetup from '../middlewares/CompleteSetup';
import DashboardLayout from '../layouts/DashboardLayout';
import { getCaseDetail, getCases } from '../adapters/caseResolution';
import { myProfile } from '../adapters/profle';
import NoPage from '../pages/NoPage';
import Settings from '../pages/user/Settings';
import {
    getAuthToken
} from '../adapters/authentication';

const userGuard = () => {
    const token = getAuthToken();
    return token !== null && token !== undefined
}

export const userRoutes = {
    path: "/account",
    element: <>
        <Authenticated>
            <VerifiedMember>
                <CompleteSetup>
                    <DashboardLayout />
                </CompleteSetup>
            </VerifiedMember>
        </Authenticated>
    </>,
    errorElement: <NoPage />,
    children: [

        {
            path: "dashboard",
            element: <Authenticated>
                <Dashboard />
            </Authenticated>,
            loader: async () => {
                try {
                    if (userGuard()){
                        const cases = await getCases().then(res => res.data);
                        return cases ?? {};
                    }
                    return null;
                } catch (e) {
                    throw new Response("Not Found", {
                        status: 503
                    });
                }
            }
        },

        {
            path: "profile",
            element: <MyProfile />,
            loader: async () => {
                try {
                    if (userGuard()){
                        const profile = await myProfile().then((res) => res.data);
                        return profile ?? {};
                    }
                    return {};
                } catch (e) {
                    throw new Response("Not Found", {
                        status: 503
                    });
                }
            }
        },

        {
            path: "profile/edit/:type",
            element: <Settings />,
            loader: async () => {
                try {
                    const profile = await myProfile().then((res) => res.data);
                    return profile ?? {};
                } catch (e) {
                    throw new Response("Not Found", {
                        status: 503
                    });
                }
            }
        },

        {
            path: "create-case",
            element: <CreateCase />,
        },

        {
            path: "accept-invite/:caseId",
            element: <AcceptInvite />,
            loader: async ({ params }) => {
                if (userGuard()) {
                    const caseDetail = await getCaseDetail(params.caseId).then((res) => {
                        if(res.status === 200) {
                            return res.data ?? {};
                        }else{
                        throw new Response("Not Found", {
                            status: 404
                        });
                        }
                    })
                    return caseDetail;
                }
                return;
            }
        },

        {
            path: "case-detail/:id",
            element: <CaseDetail />,
            loader: async ({ params }) => {
                if (userGuard()) {
                    const caseDetail = await getCaseDetail(params.id).then((res) => {
                        if(res.status === 200){
                            return res.data
                        }else{
                            throw new Response("Not Found", {
                                status: 404
                            });
                        }
                    })
                    return caseDetail;
                }
                return;
            }
        },

    ]
};